const initCandidate = (key, officeId) => ({
  lastName: '',
  firstName: '',
  officeId,
  key
})

export default initCandidate
